import { render, staticRenderFns } from "./taskHistoryByBatch.vue?vue&type=template&id=208828a8&scoped=true&"
import script from "./taskHistoryByBatch.vue?vue&type=script&lang=js&"
export * from "./taskHistoryByBatch.vue?vue&type=script&lang=js&"
import style0 from "./taskHistoryByBatch.vue?vue&type=style&index=0&id=208828a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "208828a8",
  null
  
)

export default component.exports